<template>
    <div>
        <div class="journey-planner__title">
            <h4>Trip Planner</h4>
            <div class="journey-planner__actions">
                <button
                    @click="handleShare"
                    class="journey-planner__action"
                    v-if="listingsExist"
                >
                    <Share></Share>Share
                </button>
            </div>
        </div>
        <draggable
            :list="trip.data"
            item-key="title"
            ghost-class="shortlist-item--ghost"
            @end="handleDayEnd"
            group="journey-planner"
            :style="dayWrapperStyle"
            ref="daywrapper"
            class="journey-planner__day-wrapper"
            :disabled="isMobile"
        >
            <template #item="{ element, index }">
                <div>
                    <div class="journey-planner__day">
                        <div class="journey-planner__day-title">
                            <h5>Day {{ index + 1 }}</h5>
                            <div class="journey-planner__day-actions">
                                <button
                                    class="backspace"
                                    @click="handleRemoveDay(index)"
                                    v-if="trip.data[index].listings.length > 0"
                                >
                                    <Backspace></Backspace>
                                </button>
                                <button
                                    class="remove"
                                    @click="handleRemoveDay(index)"
                                    v-else
                                >
                                    <Trash></Trash>
                                </button>
                                <button class="drag">
                                    <Drag></Drag>
                                </button>
                            </div>
                        </div>
                        <div class="journey-planner__day-listings">
                            <draggable
                                :list="element.listings"
                                item-key="title"
                                ghost-class="shortlist-item--ghost"
                                @end="handleListingEnd"
                                @change="handleListingChange"
                                group="listings"
                            >
                                <template #item="{ element }">
                                    <ShortlistItem
                                        :id="element.id"
                                        :image="element.image"
                                        :title="element.title"
                                        :summary="element.summary"
                                        :link="element.link"
                                        :removeicon="'backspace'"
                                        @remove="
                                            handleRemoveListing(
                                                element.id,
                                                index
                                            )
                                        "
                                    >
                                    </ShortlistItem>
                                </template>
                            </draggable>
                            <draggable
                                :list="dropzone"
                                item-key="title"
                                ghost-class="shortlist-item--ghost"
                                @change="
                                    (e) => {
                                        handleDropzone(e, index);
                                    }
                                "
                                :group="{
                                    name: 'listings',
                                    pull: false,
                                }"
                            >
                                <template #item="{ element }">
                                    <div
                                        class="planner-dropzone"
                                        :id="element.id"
                                    >
                                        <p
                                            class="planner-dropzone__instructions"
                                        >
                                            <span>+</span> Drag in item to add
                                        </p>
                                        <p
                                            v-if="isLastDayNoListings(index)"
                                            class="planner-dropzone__empty-message"
                                        >
                                            Or start with one of the popular
                                            trips below
                                        </p>
                                    </div>
                                </template>
                            </draggable>
                        </div>
                    </div>
                </div>
            </template>
        </draggable>
        <div class="journey-mobile-navigation" v-show="showMobileNav">
            <button
                v-show="focusDay > 1"
                @click="decrementDayFocus"
                class="journey-mobile-navigation-prev"
            >
                <ChevronLeft> </ChevronLeft>
            </button>
            <button
                v-show="trip.data.length > 1 && focusDay != trip.data.length"
                @click="incrementDayFocus"
                class="journey-mobile-navigation-next"
            >
                <ChevronRight> </ChevronRight>
            </button>
        </div>
        <div class="journey-dropzone" @click="addDay" v-if="isLastDay">
            <span>+</span> <span class="journey-dropzone-text">add day</span>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import { searchToObject } from "@/helpers/urlHelpers";
import ShortlistItem from "@/vue/components/ShortlistItem";
import Trash from "@/vue/icons/Trash";
import Drag from "@/vue/icons/Drag";
import Share from "@/vue/icons/Share";
import Backspace from "@/vue/icons/Backspace";
import ChevronLeft from "@/vue/icons/ChevronLeft";
import ChevronRight from "@/vue/icons/ChevronRight";
import ModalShare from "@/vue/components/ModalShare";
import { useTripStore } from "@/vue/stores/trip.js";
import { useShortlistStore } from "@/vue/stores/shortlist";
import { useModalStore } from "@/vue/stores/modal";

export default {
    components: {
        draggable,
        ShortlistItem,
        Trash,
        Drag,
        Share,
        Backspace,
        ChevronLeft,
        ChevronRight,
    },
    props: {
        servertrip: Array,
    },
    data() {
        return {
            dropzone: [{ id: 0 }],
            trip: useTripStore(),
            shortlist: useShortlistStore(),
            modal: useModalStore(),
            focusDay: 1,
            isMobile: false,
            showMobileNav: true
        };
    },
    created() {
        const object = searchToObject(window.location.search);

        if (object.t) {
            this.trip.replaceData(this.servertrip);
        } else {
            this.trip.getData();
        }
    },
    mounted() {
        this.watchResolution();
        this.watchMobileNavPosition();
    },
    computed: {
        isLastDay() {
            return (
                this.focusDay === this.trip.data.length ||
                this.trip.data.length === 1
            );
        },
        listingsExist() {
            if (this.trip.data[0] && this.trip.data[0].listings) {
                return this.trip.data[0].listings.length > 0;
            }
            return false;
        },
        dayWrapperStyle() {
            let n = this.trip.data.length;
            const style = {};
            style.gridTemplateColumns = `repeat(${n}, 1fr)`;
            style.width = `${n * 100}%`;

            const index = this.focusDay - 1;
            let x = 0;

            if (index != 0) {
                let y = 100 / n;
                x = y * index * -1;
            }

            if (this.$refs.daywrapper !== undefined) {

                const wrapperEl = this.$refs.daywrapper.targetDomElement
                const dayEl = wrapperEl.children[index]

                if(dayEl && index > 0) {
                    const h = dayEl.children[0].getBoundingClientRect().height
                    style.height = h + 'px'
                    style.overflow = 'hidden'
                }
            }

            style.transform = `translateX(${x}%)`;

            return style;
        },
    },
    methods: {
        watchMobileNavPosition() {

            const el = this.$refs.daywrapper.targetDomElement

            let ob = new IntersectionObserver(items => {
                items.forEach(item => {
                    this.showMobileNav = item.isIntersecting
                })
            }, {
                rootMargin: '-50%'
            })

            ob.observe(el)
        },
        checkResolution() {
            this.isMobile = window.innerWidth <= 1024;
        },
        watchResolution() {
            this.checkResolution();
            window.addEventListener("resize", () => {
                this.checkResolution();
            });
        },
        isLastDayNoListings(index) {
            if (!this.trip.value[0]) {
                return true;
            }
            return (
                !this.trip.value[0].length &&
                this.trip.value.length === 1 &&
                index === 0
            );
        },
        incrementDayFocus() {
            this.focusDay = this.focusDay + 1;
        },
        decrementDayFocus() {
            if (this.focusDay > 0) {
                this.focusDay = this.focusDay - 1;
            }
        },
        handleShare: function (e) {
            this.modal.open(ModalShare, {
                value:
                    window.location.origin +
                    window.location.pathname +
                    this.trip.getTripQueryString(),
            });
        },
        handleDayEnd: function (e) {
            const object = searchToObject(window.location.search);
            const replaceStore = object.t === undefined;
            this.trip.replaceData(this.trip.data, { replaceStore });
        },
        handleListingChange: function (e) {
            this.trip.replaceData(this.trip.data);
        },
        handleListingEnd: function (e) {},
        handleDropzone: function (e, day) {
            const item = e.added.element;
            this.trip.add(item.id, item, day);
            this.dropzone = [{ id: 0 }];
        },
        handleRemoveDay: function (index) {
            if (
                this.trip.data.length === 1 &&
                this.trip.data[0].listings.length === 0
            ) {
                return;
            }
            const listings = this.trip.data[index].listings;
            this.shortlist.mergeData(listings);
            this.trip.removeDay(index);
        },
        handleRemoveListing: function (id, day) {
            const found = this.trip.data[day].listings.find((listing) => {
                return listing.id === id;
            });

            if (found) {
                this.shortlist.add(id, found);
                this.trip.remove(id, day);
            }
        },
        replaceJourney: function (journey) {},
        addDay: function () {
            this.trip.addDay();
            this.focusDay = this.trip.data.length;
        },
    },
};
</script>

<style lang="scss">
.journey-planner__title {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: calc(var(--grid-gap) / 2);
}

.journey-planner__action {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
    color: var(--color-grey-800);
    letter-spacing: 0.1em;
    border: 1px solid var(--color-grey-200);
    padding: 10px 16px;
    cursor: pointer;
}

.journey-planner__action svg {
    width: 21px;
    margin-right: 0.5em;
    color: var(--color-blue-400);
}

.journey-planner__day-wrapper {
    display: grid;
    grid-gap: var(--grid-gap);
    transition: transform 200ms cubic-bezier(0.455, 0.03, 0.515, 0.955);

    @media (min-width: 1024px) {
        transform: translateX(0) !important;
        width: 100% !important;
        display: block !important;

        > div {
            margin-bottom: var(--grid-gap);
        }
    }
}

.journey-planner__day {
    display: grid;
    grid-template-columns: auto;
    padding: calc(var(--grid-gap) / 1.5);
    border: 1px solid #e3e9ec;
    background-color: white;
    border-radius: 8px;
    cursor: grab;

    @media (min-width: 1024px) {
        padding: var(--grid-gap);
        grid-gap: var(--grid-gap);
    }

    @media (min-width: 1280px) {
        grid-template-columns: 140px auto;
    }
}

.journey-planner__day-title {
    display: flex;
    grid-row: 1;

    @media (min-width: 1024px) {
        display: block;
    }
}

.journey-planner__day-listings {
    grid-row: 2;

    @media (min-width: 1024px) {
        grid-row: 1;

        .shortlist-item {
            margin-bottom: var(--grid-gap);
        }
    }

    @media (max-width: 639px) {
        .shortlist-item {
            margin-bottom: var(--grid-gap);
        }

        .shortlist-item__content {
            grid-template-columns: auto;
        }

        .shortlist-item__details {
            padding-left: 0;
            padding-top: calc(var(--grid-gap) / 2);
        }
    }
}

.journey-planner__day:hover .journey-planner__day-actions {
    opacity: 1;
}

.journey-planner__day + .journey-planner__day {
    @media (min-width: 1024px) {
        margin-top: var(--grid-gap);
    }
}

.journey-mobile-navigation {
    position: fixed;
    top: 50%;
    left: 5px;
    width: calc(100% - 10px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    pointer-events: none;

    button {
        position: absolute;
        pointer-events: all;
        cursor: pointer;
        width: 40px;
        height: 40px;
        background-color: var(--color-blue-400);
        border-radius: 999px;
        color: var(--color-white);
        border: 1px solid var(--color-white);
    }

    .journey-mobile-navigation-prev {
        left: 0;
        //transform: translate(-50%, 50%);
    }

    .journey-mobile-navigation-next {
        right: 0;
        // transform: translate(50%, 50%);
    }

    @media (min-width: 1024px) {
        display: none;
    }
}

.journey-dropzone {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    text-transform: uppercase;
    color: var(--color-white);
    background-color: var(--color-blue-400);
    text-align: center;
    letter-spacing: 0.1em;
    font-size: 14px;
    border-radius: 999px;

    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(50%, 0%);

    @media (min-width: 1024px) {
        padding: 15px;
        margin-top: var(--grid-gap);
        min-height: 80px;
        position: relative;
        border: 1px solid #e3e9ec;
        color: var(--color-grey-900);
        background-color: white;
        border-radius: 0;
        top: unset;
        right: unset;
        transform: translate(0%, 0%);
    }
}

.journey-dropzone-text {
    display: none;

    @media (min-width: 1024px) {
        display: inline-block;
    }
}

.journey-dropzone:hover {
    cursor: pointer;
}

.planner-dropzone {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px dashed #e3e9ec;
    background-color: white;
    padding: 15px;
    min-height: 80px;
    text-align: center;
    margin-top: calc(var(--grid-gap) / 2);

    @media (min-width: 1024px) {
        margin-top: var(--grid-gap);
    }
}

.planner-dropzone__instructions {
    text-transform: uppercase;
    color: var(--color-grey-900);
    letter-spacing: 0.1em;
    font-size: 14px;
}

.planner-dropzone__empty-message {
    color: var(--color-grey-800);
    margin-top: 0.5em;
    max-width: 180px;
}

.journey-dropzone span:not(.journey-dropzone-text) {
    color: var(--color-white);
    width: 40px;
    height: 40px;
    line-height: 1;
    font-size: 2.5em;

    @media (min-width: 1024px) {
        color: var(--color-blue-400);
        padding-right: 0.5em;
        width: auto;
        height: auto;
        line-height: auto;
        font-size: inherit;
    }
}

.planner-dropzone span {
    color: var(--color-blue-400);
    padding-right: 0.5em;
}

.journey-planner__day-actions {
    display: flex;
    transition: opacity 150ms ease-in;
    margin-left: 1em;

    @media (min-width: 1024px) {
        margin-left: 0em;
        flex-direction: column;
    }

    @media (hover: hover) {
        opacity: 0;
    }
}

.journey-planner__day-actions button {
    position: relative;
    width: 21px;
    color: var(--color-grey-600);
}

.journey-planner__day-actions button + button {
    margin-left: calc(var(--grid-gap) / 4);

    @media (min-width: 1024px) {
        margin-top: calc(var(--grid-gap) / 4);
        margin-left: 0;
    }
}

.journey-planner__day-actions button:before,
.journey-planner__day-actions button:after {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 999;
    display: block;
    background-color: #333;
    color: var(--color-white);
    pointer-events: none;
    opacity: 0;
}

.journey-planner__day-actions button:before {
    content: " ";
    width: 15px;
    height: 15px;
    transform: translate(-50%, calc(-100% - 5px)) rotate(45deg);
}

.journey-planner__day-actions .backspace:hover {
    color: var(--color-red-400);
}

.journey-planner__day-actions .backspace:after {
    content: "Back to shortlist";
}

.journey-planner__day-actions .remove:hover {
    color: var(--color-red-400);
}

.journey-planner__day-actions .remove:after {
    content: "Remove";
}

.journey-planner__day-actions .drag {
    cursor: grab;
}

.journey-planner__day-actions .drag:after {
    content: "Drag";
}

.journey-planner__day-actions button:after {
    white-space: nowrap;
    padding: 4px 8px 4px 9px;
    border-radius: 5px;
    text-align: center;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: 600;
    transform: translate(-50%, calc(-100% - 10px));
}

.journey-planner__day-actions button:hover:after,
.journey-planner__day-actions button:hover:before {
    opacity: 1;
    pointer-events: all;
}
</style>
